var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Pill } from "../../../../../Components/UI";
import React from 'react';
import { Icon } from "../../../../../../UI";
import { Translate } from "../../../../../../I18N";


const entityStatusMap = {
  NEW: /*#__PURE__*/
  _jsx(Pill, { color: "indigo" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "New")
  ),

  IN_QUEUE: /*#__PURE__*/
  _jsx(Pill, { color: "gray" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "In queue")
  ),

  PROCESSING: /*#__PURE__*/
  _jsx(Pill, { color: "gray" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Processing"), "..."
  ),

  DONE: /*#__PURE__*/_jsx(Icon, { className: "text-green-600", icon: "check-circle" }),
  HAS_ERROR: /*#__PURE__*/
  _jsx(Pill, { color: "red" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Error")
  )

};

const PXEntityStatus = ({ status }) => {var _entityStatusMap$stat;
  const component = (_entityStatusMap$stat = entityStatusMap[status]) !== null && _entityStatusMap$stat !== void 0 ? _entityStatusMap$stat : /*#__PURE__*/_jsx(Pill, { color: "gray" }, void 0, status);
  return /*#__PURE__*/_jsx("div", {}, void 0, component);
};

export { PXEntityStatus };